import Main from '@/components/main'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true,
      nameText: 'router.index.login',
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true,
      nameText: 'router.index.home',
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          hideInMenu: true,
          title: '首页',
          notCache: true,
          icon: 'md-home',
          nameText: 'router.index.home',
        },
        // redirect: '/user/userInformation',
        // component: () => import('@/view/home/homePage.vue')
      }
    ]
  },
  // 用户查询
  {
    path: '/user',
    name: 'userInformation',
    component: Main,
    meta: {
      title: '用户查询管理',
      nameText: 'router.index.pageSearch1',
      id: 151,
    },
    children: [
      {
        path: 'userInformation',
        name: '用户查询',
        meta: {
          title: '用户查询',
          nameText: 'router.index.pageSearch2',
          id:151
        },
        component: () => import('@/view/userInformation/userInformation.vue'),
      },
    ]
  },
  // 房间查询
  {
    path: '/service',
    name: 'roomManagement',
    component: Main,
    meta: {
      // hideInBread: true,
      title: '房间管理',
      nameText: 'router.index.pageRoom1',
      id: 170,
    },
    children: [
      {
        path: 'roomManagement',
        name: '房间查询',
        meta: {
          title: '房间查询',
          nameText: 'router.index.pageRoom2',
          id: 170
        },
        component: () => import('@/view/roomManagement/roomManagement.vue')
      },
    ]
  },
  // 头像审核
  {
    path: '/avatarReview',
    name: 'avatarReview',
    component: Main,
    meta: {
      title: '头像审核',
      nameText: 'router.index.avatarReview',
      id: 177,
    },
    children: [
      {
        path: 'home',
        name: 'avatarReviewHome',
        meta: {
          title: '头像审核',
          nameText: 'router.index.avatarReview',
          id: 178,
        },
        component: () => import('@/view/avatarReview/avatarReview.vue'),
      },
      {
        path: 'reviewDetail',
        name: 'avatarReviewDetail',
        meta: {
          title: '头像审核详情',
          nameText: 'router.index.avatarReviewDetail',
          sideMenuItemHidden: true,
        },
        component: () => import('@/view/avatarReview/reviewDetail.vue'),
      },
    ],
  },
  // 房间背景审核
  {
    path: '/backgroundReview',
    name: 'backgroundReview',
    component: Main,
    meta: {
      title: '背景管理',
      nameText: 'router.index.pageBg',
      id: 179,
    },
    children: [
      {
        path: 'home',
        name: '背景管理',
        meta: {
          title: '背景管理',
          nameText: 'router.index.pageBg',
          id:180
        },
        component: () => import('@/view/backgroundReview/backgroundReview.vue'),
      },
    ]
  },
  // banner
  {
    path: "/roomColumn",
    name: "roomColumn",
    component: Main,
    meta: {
      title: "房间专栏",
      nameText: "router.index.roomColumn",
      id: 285,
    },
    children: [
      {
        path: "index",
        name: "房间专栏",
        meta: {
          title: "房间专栏",
          id: 286,
          nameText: "router.index.roomColumn"
        },
        // component: () => import("@/view/roomColumn/index.vue")
        component: () => import("@/view/roomColumn/operationalPopup.vue")
      },
    ]
  },
  // 相册审核
  {
    path: '/albumReview',
    name: 'albumReview',
    component: Main,
    meta: {
      title: '相册审核',
      nameText: 'router.index.albumReview',
      id: 181,
    },
    children: [
      {
        path: 'home',
        name: 'albumReviewHome',
        meta: {
          title: '相册审核',
          nameText: 'router.index.albumReview',
          id: 182
        },
        component: () => import('@/view/albumReview/albumReview.vue'),
      },
    ],
  },
  // 广播管理
  {
    path: '/broadcastManagement',
    name: 'broadcastManagement',
    component: Main,
    meta: {
      title: '广播管理',
      nameText: 'router.index.broadcastManagement',
      id: 183,
    },
    children: [
      {
        path: 'home',
        name: 'broadcastManagementHome',
        meta: {
          title: '广播管理',
          nameText: 'router.index.broadcastManagement',
          id:184
        },
        component: () => import('@/view/broadcastManagement/broadcastManagement.vue'),
      }
    ],
  },
// Square社区管理
  {
    path: '/community',
    name: 'community',
    component: Main,
    meta: {
      title: '社区后台',
      nameText: 'router.index.community',
      id: 185,
    },
    children: [
      {
        path: 'contentReview',
        name: 'contentReview',
        meta: {
          title: '帖子审核',
          nameText: 'router.index.contentReview',
          id: 186,
        },
        component: () => import('@/view/community/contentReview/contentReview'),
      },
      {
        path: 'reportManagement',
        name: 'reportManagement',
        meta: {
          title: '举报管理',
          nameText: 'router.index.reportManagement',
          id: 187,
        },
        component: () => import('@/view/community/reportManagement/reportManagement.vue'),
      },
      {
        path: 'topicReview',
        name: 'topicReview',
        meta: {
          title: '话题审核',
          nameText: 'router.index.topicReview',
          id: 188,
        },
        component: () => import('@/view/community/topicReview/topicReview'),
      },
      {
        path: 'topicManagement',
        name: 'topicManagement',
        meta: {
          title: '官方话题管理',
          nameText: 'router.index.topicManagement',
          id: 190,
        },
        component: () => import('@/view/community/topicManagement/topicManagement'),
      },
      {
        path: 'auditorManagement',
        name: 'auditorManagement',
        meta: {
          title: '审核人员管理',
          nameText: 'router.index.auditorManagement',
          id: 189,
        },
        component: () => import('@/view/community/auditorManagement/components/auditManagement.vue'),
      },
      {
        path: 'postPermiss',
        name: 'postPermiss',
        meta: {
          title: '发帖权限',
          nameText: 'router.index.postingPermiss',
          id: 246,
        },
        component: () => import('@/view/community/postingPermiss/postingPermiss.vue'),
      },




      // {
      //   path: 'anomaly',
      //   name: 'anomaly',
      //   meta: {
      //     title: '社区异常操作上报',
      //     nameText: 'router.index.anomaly',
      //     id: 142,
      //   },
      //   component: () => import('@/view/community/communityAnomaly/communityAnomaly.vue'),
      // },
      // {
      //   path: 'statistics',
      //   name: 'statistics',
      //   meta: {
      //     title: '日常统计',
      //     nameText: 'router.index.statistics',
      //     id: 223,
      //   },
      //   component: () => import('@/view/community/statistics/statistics.vue'),
      // },
      // {
      //   path: 'annualCeremony',
      //   name: 'annualCeremony',
      //   meta: {
      //     title: '年度盛典',
      //     nameText: 'router.index.annualCeremony',
      //     id: 496,
      //   },
      //   component: () => import('@/view/community/annualCeremony/annualCeremony.vue'),
      // },
    ],
  },
  // 群组审核
  {
    path: '/groupReview',
    name: 'groupReview',
    component: Main,
    meta: {
      title: '群组审核',
      id: 263,
      nameText: 'router.index.pageGroup',
    },
    children: [
      {
        path: 'avatarReview',
        name: '头像审核',
        meta: {
          title: '头像审核',
          nameText: 'router.index.avatarReview',
          id:264
        },
        component: () => import('@/view/groupReview/avatarReview.vue'),
      },
      {
        path: 'reportReview',
        name: '举报审核',
        meta: {
          title: '举报审核',
          nameText: 'router.index.reportReview',
          id:265
        },
        component: () => import('@/view/groupReview/reportReview.vue'),
      },
    ]
  },
  // 活动审核
  {
    path: '/activityReview',
    name: 'activityReview',
    component: Main,
    meta: {
      title: '活动申请',
      id: 191,
      nameText: 'router.index.pageActivity',
    },
    children: [
      {
        path: 'home',
        name: '活动申请',
        meta: {
          title: '活动申请',
          nameText: 'router.index.pageActivity',
          id:192
        },
        component: () => import('@/view/activityReview/activityReview.vue'),
      },
    ]
  },
  // 用户举报列表
  {
    path: '/userReport',
    name: 'userReport',
    component: Main,
    meta: {
      title: '用户举报',
      nameText: 'router.index.pageUser1',
      id: 193,
    },
    children: [
      {
        path: 'home',
        name: '用户举报列表',
        meta: {
          title: '用户举报',
          nameText: 'router.index.pageUser1',
          id:194
        },
        component: () => import('@/view/userReport/userReport.vue'),
      },
    ]
  },
  // 申诉大厅
  {
    path: '/appealHall',
    name: 'appealHall',
    component: Main,
    meta: {
      title: '申诉大厅',
      nameText: 'router.index.pageAppealHall',
      id: 195,
    },
    children: [
      {
        path: 'home',
        name: '申诉大厅',
        meta: {
          title: '申诉大厅',
          nameText: 'router.index.pageAppealHall',
          id:196
        },
        component: () => import('@/view/appealHall/appealHall.vue'),
      },
      {
        path: 'moreUserIpList',
        name: '查看更多ip',
        meta: {
          title: '查看更多ip',
          sideMenuItemHidden: true, // 在侧边栏隐藏该页面跳转链接
          nameText: 'router.index.pageMoreIp',
        },
        component: () => import('@/view/appealHall/moreUserIpList.vue'),
      },
    ]
  },
  // 机器举报列表
  {
    path: '/machineReport',
    name: 'machineReport',
    component: Main,
    meta: {
      title: '机器举报',
      nameText: 'router.index.pageMachine1',
      id: 197,
    },
    children: [
      {
        path: 'home',
        name: '机器举报列表',
        meta: {
          title: '机器举报',
          nameText: 'router.index.pageMachine1',
        },
        component: () => import('@/view/machineReport/machineReport.vue'),
      },
    ]
  },
  // 退款明细
  // {
  //   path: '/refundDetail',
  //   name: 'refundDetail',
  //   component: Main,
  //   meta: {
  //     title: '退款明细',
  //     nameText: 'router.index.pageAppealHall',
  //     id: 663,
  //   },
  //   children: [
  //     {
  //       path: 'index',
  //       name: '退款明细',
  //       meta: {
  //         title: '退款明细',
  //         nameText: 'router.index.refundDetail',
  //       },
  //       component: () => import('@/view/refundDetail/index.vue'),
  //     },
  //
  //   ]
  // },
  // 家族查询
  {
    path: '/familyInformation',
    name: 'familyInformation',
    component: Main,
    meta: {
      title: '家族信息查询',
      nameText: 'router.index.pageFamily1',
      id: 201,
    },
    children: [
      {
        path: 'home',
        name: '家族信息查询列表',
        meta: {
          title: '家族信息查询',
          nameText: 'router.index.pageFamily2',
          id:202
        },
        component: () => import('@/view/familyInformation/familyInformation.vue'),
      },
      {
        path: 'familyMember',
        name: '家族成员列表',
        meta: {
          title: '家族成员列表',
          sideMenuItemHidden: true, // 在侧边栏隐藏该页面跳转链接
          nameText: 'router.index.pageFamily3',
          id: 202
        },
        component: () => import('@/view/familyInformation/familyMember.vue'),
      },
    ]
  },
  // 群组管理
  {
    path: "/group",
    name: "groupManagement",
    component: Main,
    meta: {
      title: "群组管理",
      nameText: "router.index.groupManagement",
      id: 302,
    },
    children: [
      {
        path: "index",
        name: "查看群组管理",
        meta: {
          title: '查看群组管理',
          nameText: "router.index.groupManagement",
          id:298
        },
        component: () => import('@/view/groupManagement/index.vue'),
      },
      {
        path: 'groupManagement/groupDetail',
        name: '群组详情',
        meta: {
          title: '群组详情',
          sideMenuItemHidden: true, // 在侧边栏隐藏该页面跳转链接
          nameText: 'router.index.pageSearch4',
          id: 298
        },
        component: () => import('@/view/groupManagement/groupDetail.vue'),
      },
    ]
  },
  // ID列表
  {
    path: '/applyNoList',
    name: 'applyNoList',
    component: Main,
    meta: {
      title: '申请ID',
      id: 203,
      nameText: 'router.index.pageApplicatId1',
    },
    children: [
      {
        path: 'home',
        name: 'ID列表',
        meta: {
          title: 'ID列表',
          nameText: 'router.index.pageApplicatId2',
          id: 204
        },
        component: () => import('@/view/application/application.vue'),
      },
    ]
  },
  // 客服工作站
  {
    path: '/problems',
    name: 'problems',
    component: Main,
    meta: {
      title: '客服工作站',
      id: 205,
      nameText: 'router.index.pageProblem',
    },
    children: [
      {
        path: 'pageProblem',
        name: '问题统计',
        meta: {
          title: '问题统计',
          nameText: 'router.index.pageProblem1',
          id:206,
        },
        component: () => import('@/view/problems/problems.vue'),
      },
      {
        path: 'pageService',
        name: '工作统计及账号管理',
        meta: {
          title: '工作统计及账号管理',
          nameText: 'router.index.pageService1',
          id:207
        },
        component: () => import('@/view/problems/index.vue'),
      },
      {
        path: 'pageKnowledge',
        name: '热门QA管理',
        meta: {
          title: '热门QA管理',
          nameText: 'router.index.pageKnowledge1',
          id:213
        },
        component: () => import('@/view/knowledgeList/knowledgeList.vue'),
      },
      {
        path: 'pageQsBank',
        name: '客服知识库',
        meta: {
          title: '客服知识库',
          nameText: 'router.index.pageQsBank2',
          id:214
        },
        component: () => import('@/view/questionBank/questionBank.vue'),
      },
      {
        path: 'problemsDetail',
        name: 'problemsDetail',
        meta: {
          title: '问题统计详情',
          sideMenuItemHidden: true, // 在侧边栏隐藏该页面跳转链接
          nameText: 'router.index.pageProblem2',
          id: 206,
        },
        component: () => import('@/view/problems/problemsDetail.vue'),
      },
    ]
  },
  // 登录反馈
  {
    path: '/loginFeedback',
    name: 'loginFeedback',
    component: Main,
    meta: {
      title: '登录反馈',
      nameText: 'router.index.loginFeedback1',
      id: 215,
    },
    children: [
      {
        path: 'index',
        name: '登录反馈列表',
        meta: {
          title: '登录反馈列表',
          nameText: 'router.index.loginFeedback2',
          id:216
        },
        component: () => import('@/view/loginFeedback/index.vue'),
      },
      {
        path: 'loginFeed/:id',
        name: '登录反馈详情',
        meta: {
          title: '登录反馈详情',
          nameText: 'router.index.loginFeedback3',
          sideMenuItemHidden: true, // 在侧边栏隐藏该页面跳转链接
          id:216
        },
        component: () => import('@/view/loginFeedback/loginFeedDetail.vue'),
      },
    ],
  },
  // 当前所在房间
  {
    path: '/nowMemberInroom',
    name: 'nowMemberInroom',
    component: Main,
    meta: {
      title: '用户当前房间',
      nameText: 'router.index.nowMemberInroom1',
      id: 217,
    },
    children: [
      {
        path: 'home',
        name: '用户当前房间列表',
        meta: {
          title: '用户当前房间列表',
          nameText: 'router.index.nowMemberInroom2',
          id:218
        },
        component: () => import('@/view/nowMemberInroom/index.vue'),
      },
    ],
  },
  // 客服工作统计
  {
    path: '/questionStatistics',
    name: 'questionStatistics',
    component: Main,
    meta: {
      title: '客服工作统计列表',
      id: 219,
      nameText: 'router.index.pageService2',
    },
    children: [
      {
        path: 'operationLog',
        name: '操作日志',
        // component: () => import('@/view/questionStatistics/questionStatistics.vue'),
        component: () => import('@/view/questionStatistics/operationLog.vue'),
        meta: {
          title: '操作日志',
          nameText: 'router.index.operationLog',
          id: 220,
        },
      },
    ],
  },
  // 管理帐号设置

  {
    path: '/account',
    name: 'account',
    component: Main,
    meta: {
      title: '管理员账号设置',
      nameText: 'router.index.pageAccount1',
      id: 221,
    },
    children: [
      {
        path: 'home',
        name: '管理员账号设置列表',
        meta: {
          title: '管理员账号设置列表',
          nameText: 'router.index.pageAccount2',
          id: 222
        },
        component: () => import('@/view/account/account.vue'),
      },
    ],
  },
  // 角色权限管理
  {
    path: '/authorityManagement',
    name: 'authorityManagement',
    component: Main,
    meta: {
      title: '角色权限管理',
      nameText: 'router.index.pageManagement1',
      id: 226,
    },
    children: [
      {
        path: 'home',
        name: '角色权限管理列表',
        meta: {
          title: '角色权限管理列表',
          nameText: 'router.index.pageManagement2',
          id: 227
        },
        component: () => import('@/view/authorityManagement/authorityManagement.vue'),
      },

      {
        path: 'module',
        name: '模块权限管理',
        meta: {
          title: '模块权限管理',
          hideInMenu: true,

          nameText: 'views.authorityManagement.text1',
        },
        component: () => import('@/view/authorityManagement/modulePermissions.vue'),
      },
      {
        path: 'propsLimit',
        name: '道具限制管理',
        meta: {
          title: '道具限制管理',
          hideInMenu: true,

          nameText: 'views.authorityManagement.text6',
        },
        component: () => import('@/view/authorityManagement/propsLimit.vue'),
      },
    ]
  },
  // newend

  // 管理员
  // {
  //   path: '/superTube',
  //   name: 'superTube',
  //   component: Main,
  //   meta: {
  //     title: '超级管理员',
  //     nameText: 'router.index.pageSuperTube1',
  //     id: 81,
  //   },
  //   children: [
  //     {
  //       path: 'superTube',
  //       name: '超级管理员',
  //       meta: {
  //         title: '超级管理员',
  //         nameText: 'router.index.pageSuperTube2',
  //         id: 82,
  //       },
  //       component: () => import('@/view/superTube/superTube.vue')
  //     },
  //     {
  //       path: 'national',
  //       name: '国家管理员',
  //       meta: {
  //         title: '国家管理员',
  //         nameText: 'router.index.pageSuperTube3',
  //         id: 83,
  //       },
  //       component: () => import('@/view/superTube/national.vue')
  //     }
  //   ],
  // },













  // 客服账号管理列表
  // {
  //   path: '/serviceManagement',
  //   name: 'serviceManagement',
  //   component: Main,
  //   meta: {
  //     title: '客服账号管理',
  //     id: 59,
  //     nameText: 'router.index.pageAccout1',
  //   },
  //   children: [
  //     {
  //       path: 'home',
  //       name: '客服账号管理列表',
  //       meta: {
  //         title: '客服账号管理',
  //         nameText: 'router.index.pageAccout2',
  //       },
  //       component: () => import('@/view/serviceManagement/serviceManagement.vue'),
  //     },
  //   ]
  // },

  // 丢单信息查询
  // {
  //   path: '/lostOrder',
  //   name: 'lostOrder',
  //   component: Main,
  //   meta: {
  //     title: '丢单信息管理',
  //     nameText: 'router.index.pageLost1',
  //     id: 89,
  //   },
  //   children: [
  //     {
  //       path: 'home',
  //       name: '丢单信息管理列表',
  //       meta: {
  //         title: '丢单信息管理列表',
  //         nameText: 'router.index.pageLost2',
  //       },
  //       component: () => import('@/view/lostOrder/lostOrder'),
  //     },
  //   ],
  // },



  {
    path: '/systemBlacklist',
    name: 'systemBlacklist',
    component: Main,
    meta: {
      title: '账号黑名单',
      nameText: 'router.index.systemBlacklist1',
      id: 999,
    },
    children: [
      {
        path: 'index',
        name: '账号黑名单',
        meta: {
          title: '账号黑名单',
          nameText: 'router.index.systemBlacklist2',
        },
        component: () => import('@/view/systemBlacklist/index.vue'),
      },
    ],
  },
  // 测试
  // {
  //   path: '/activity-support',
  //   name: 'activity-support',
  //   component: Main,
  //   meta: {
  //     title: '活动扶持统计',
  //     nameText: 'router.index.activitySuppor',
  //     id: -1,
  //   },
  //   children: [
  //     {
  //       path: 'index',
  //       name: '活动扶持统计',
  //       meta: {
  //         title: '活动扶持统计',
  //         nameText: 'router.index.activitySuppor',
  //         id: -1,
  //       },
  //       component: () => import('@/view/activity-support/activity-support.vue'),
  //     },
  //   ],
  // },
  // 测试结束
  // {
  //   path: '/couple-page',
  //   name: 'couple-page',
  //   component: Main,
  //   meta: {
  //     title: 'Couple活动入口',
  //     nameText: 'router.index.couplePage1',
  //     id: -1,
  //   },
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'Couple活动入口',
  //       meta: {
  //         title: 'Couple活动入口',
  //         nameText: 'router.index.couplePage1',
  //         id: -1,
  //       },
  //       component: () => import('@/view/couplePage/index.vue'),
  //     },
  //   ],
  // },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true,
      nameText: 'router.index.error401',
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true,
      nameText: 'router.index.error500',
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true,
      nameText: 'router.index.error404',
    },
    component: () => import('@/view/error-page/404.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/routers.js